export default {
  channelSocialName: 'ชื่อเรียก',
  channelSocialDetail: 'รายละเอียด',
  channelSocialStatus: 'สถานะ',
  channelSocialSocial: 'โซเชี่ยล',
  channelSocialURL: 'รายละเอียดบัญชีเพิ่มเติม',
  channelSocialWarehouseID: 'คลังสินค้า',
  channelSocialWarehouseName: 'คลังสินค้า',
  channelSocialSale: 'พนักงานขาย'
};
